module.exports = __webpack_public_path__ + "r-v3/img/set_display.c494296b.svg";